import React from 'react';
import { motion } from 'framer-motion';

const Journey = () => {
  return (
    <section id="programs" className="py-20 md:py-28 bg-neutral-50">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-[40px] md:text-[56px] leading-[1.05] tracking-tight font-semibold text-neutral-900"
        >
          My journey<br />to becoming a tutor.
        </motion.h2>

        <div className="mt-10 md:mt-14 space-y-6 text-[15px] md:text-[16px] leading-[1.75] text-neutral-700">
          {[
            'I began tutoring in 2020 while completing my GCSEs, where I achieved 8s in Combined Science and discovered a genuine passion for helping others succeed.',
            "During my A-Levels, I continued tutoring while earning A* in Biology, A* in French, and A in Chemistry. Along the way, I developed the clarity, structure, and exam-focused strategies I now teach my own students.",
            "Since then, I've supported hundreds of students across the UK and internationally — helping them build confidence, master content, and achieve the grades they're deserve.",
          ].map((text, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
            >
              {text}
            </motion.p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Journey;
